import $ from "jquery";
import React, { Component } from "react";
import { Field, formValueSelector } from "redux-form";
import { connect } from "react-redux";
import { Row, Column } from "react-foundation";
import Loading from "components/Loading";
import Select from "react-select";

import { getWindowWERList } from "./../../selectors";

import InputError from "../../components/InputError";
import ThemeButton from "../../components/ThemeButton";
import bfrcLogo from "../../images/bfrc-logo.svg";
import SeparatingLine from "../../components/SeparatingLine";
import FormHeader from "../../components/FormHeader";
import FormWrapper from "../FormWrapper";
import efficiencyImageAPlus from "../../images/A+ label.png";
import efficiencyImageA from "../../images/A label.png";
import efficiencyImageC from "../../images/C label.png";

const EfficiencyImages = {
    APlus: efficiencyImageAPlus,
    A: efficiencyImageA,
    C: efficiencyImageC
};

const PrettifyEfficiency = ({ value }) => {
    return (
        <span className="efficiency-value">
            <span className="efficiency-value-letter">{value.replace(/plus/i, "")}</span>
            <span className="efficiency-value-plus">
                {value.replace(/plus/i, "+").replace(/[^+]/, "")}
            </span>
        </span>
    );
};

const SelectEfficiency = props => {
    let { efficiencies, input } = props;

    if ($.isEmptyObject(efficiencies)) {
        return <Loading />;
    }

    var options = efficiencies.map(e => ({
        value: e.id,
        label: <PrettifyEfficiency value={e.name} />
    }));

    return (
        <div>
            <Row>
                <Column
                    small={12}
                    medium={11}
                    large={10}
                    centerOnSmall
                    className="efficiency-choice"
                >
                    {"I'm looking to achieve a WER of "}
                    <Select
                        className="efficiency-select"
                        onChange={val => input.onChange(val.value)}
                        options={options}
                        value={input.value}
                        clearable={false}
                        searchable={false}
                        placeholder=""
                    />
                </Column>
            </Row>
            <InputError metas={props.meta} />
        </div>
    );
};

class EfficiencyForm extends Component {
    render() {
        return (
            <form
                onSubmit={this.props.handleSubmit(this.props.onSubmit)}
                className="EfficiencyForm"
            >
                <FormHeader
                    title={"Energy Efficiency"}
                    subtitle={
                        "We offer a range of glazing solutions to suit your requirements and budget."
                    }
                />

                <SeparatingLine />

                <FormWrapper>
                    <Field
                        name="WindowEfficiencyId"
                        component={SelectEfficiency}
                        efficiencies={this.props.efficiencies}
                    />

                    <Row>
                        <Column large={10} centerOnSmall>
                            <Row>
                                <Column small={11} centerOnSmall uncenterOnMedium medium={6} className="wer-explanation">
                                    <p>
                                        <br />
                                        {
                                            "Choosing more efficient windows and doors will increase your initial costs but lower your ongoing heating bills. They can also increase your house's resale value."
                                        }
                                        <br />
                                    </p>
                                    {EfficiencyImages[this.props.selectedEfficiency.name] && (
                                        <div className="wer-image hide-for-medium">
                                            <img
                                                src={
                                                    EfficiencyImages[
                                                        this.props.selectedEfficiency.name
                                                    ]
                                                }
                                                alt=""
                                            />
                                            <SeparatingLine />
                                        </div>
                                    )}
                                    <p>
                                        <br />
                                        <img src={bfrcLogo} alt="BFRC" className="bfrc-logo" />
                                        <br />
                                        {
                                            "Your windows will be provided with an Energy Performance Certificate that states the achieved WER (Window Energy Rating), as defined by the British Fenestration Ratings Council."
                                        }
                                    </p>
                                </Column>
                                {EfficiencyImages[this.props.selectedEfficiency.name] && (
                                    <Column small={12} medium={6} hideOnlyFor={"small"}>
                                        <div className="wer-image">
                                            <img
                                                src={
                                                    EfficiencyImages[
                                                        this.props.selectedEfficiency.name
                                                    ]
                                                }
                                                alt=""
                                            />
                                            <SeparatingLine />
                                        </div>
                                    </Column>
                                )}
                            </Row>
                        </Column>
                    </Row>
                </FormWrapper>

                <div className="button-panel">
                    <SeparatingLine />
                    <button className="button back" type="button" onClick={this.props.previousPage}>
                        Back
                    </button>
                    <ThemeButton className="next">Next</ThemeButton>
                </div>
            </form>
        );
    }
}

const mapStateToProps = state => {
    let valueSelector = formValueSelector("WindowWizard");
    let windowStyleId = valueSelector(state, "WindowStyleId");
    let efficiencyId = valueSelector(state, "WindowEfficiencyId");

    let efficiencies = getWindowWERList(state);

    let selectedEfficiency = efficiencies.filter(c => c.id === efficiencyId)[0] || {};

    return {
        efficiencies,
        selectedEfficiency,
        windowStyleId
    };
};

export default connect(
    mapStateToProps,
    {}
)(EfficiencyForm);



// WEBPACK FOOTER //
// ./src/containers/WindowForm/EfficiencyForm.js